import React, { useContext } from "react";

// Material UI
import Button from "@material-ui/core/Button";
import AddCircleIcon from "@material-ui/icons/AddCircle";

// Styling
import "./style.scss";

// global state
import { StateContext } from "../../AppStateContext";

const AddClassFormAddNewPropertyButton = ({ setIsAddPropertyModalOpen }) => {
  // Consume global state
  const state = useContext(StateContext);

  // To open the add property modal
  const openModal = () => {
    setIsAddPropertyModalOpen(true);
  };
  return (
    <div className="__addClassFormAddNewPropertyButton">
      <Button
        id="schemaAddNewPropertyModalOpenButton"
        onClick={openModal}
        variant="contained"
        startIcon={
          <AddCircleIcon
            style={{
              fontSize: "28px",
              color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
            }}
          />
        }
        style={{
          fontFamily: "Alegreya Sans, sans-serif",
          textTransform: "capitalize",
          background: state.theme === "dark" ? "#122742" : "#e2e9ff",
          color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
          fontWeight: "400",
          borderRadius: "0",
          boxShadow: "none",
        }}
      >
        Add New Property
      </Button>
    </div>
  );
};

export default AddClassFormAddNewPropertyButton;
